'use client';
import React, { useState } from 'react';
import { Plus, Trash2, CheckCircle, XCircle, Edit2 } from 'lucide-react';
import { toast } from 'sonner';

// Backend integration: GET/POST/DELETE /api/webhooks
const webhooks = [
  { id: 'wh-001', name: 'ServiceJockey Job Updates', url: 'https://api.servicejockey.io/webhooks/fleet-inbound', events: ['job.created', 'job.status_changed', 'job.completed'], status: 'active', lastDelivery: '13:54', lastStatus: 200, deliveryRate: 99.8 },
  { id: 'wh-002', name: 'RigJockey Asset Sync', url: 'https://api.rigjockey.com/fleet/webhooks/receive', events: ['asset.status_changed', 'asset.assigned', 'geofence.violation'], status: 'active', lastDelivery: '13:38', lastStatus: 200, deliveryRate: 97.2 },
  { id: 'wh-003', name: 'Ops Slack Alerts', url: 'https://hooks.slack.com/services/T04XXXXX/B04XXXXX/xxxxxxxx', events: ['alert.critical', 'job.delayed', 'gps.signal_lost'], status: 'active', lastDelivery: '13:51', lastStatus: 200, deliveryRate: 100 },
  { id: 'wh-004', name: 'QuickBooks Cost Export', url: 'https://developer.intuit.com/v2/webhooks/fleetjockey', events: ['job.completed', 'job.invoiced'], status: 'inactive', lastDelivery: 'Dec 14, 2025', lastStatus: 401, deliveryRate: 43.1 },
];

export default function WebhookPanel() {
  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-sm font-semibold text-zinc-200">Webhooks</h2>
          <p className="text-xs text-zinc-500 mt-0.5">Send real-time event notifications to external systems when fleet events occur</p>
        </div>
        <button
          onClick={() => toast?.success('Webhook endpoint added')}
          className="flex items-center gap-2 px-3 py-2 bg-amber-500 hover:bg-amber-400 text-zinc-950 text-xs font-semibold rounded-lg transition-all active:scale-95"
        >
          <Plus size={13} /> Add Endpoint
        </button>
      </div>
      <div className="space-y-3">
        {webhooks?.map((wh) => (
          <div key={wh?.id} className={`bg-zinc-900 border rounded-xl p-4 transition-all hover:border-zinc-700 ${wh?.status === 'inactive' ? 'border-zinc-800 opacity-60' : 'border-zinc-800'}`}>
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <p className="text-sm font-semibold text-zinc-200">{wh?.name}</p>
                  <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full border ${wh?.status === 'active' ? 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20' : 'bg-zinc-700 text-zinc-500 border-zinc-600'}`}>
                    {wh?.status}
                  </span>
                </div>
                <code className="text-[11px] font-mono text-zinc-500 truncate block max-w-[400px]">{wh?.url}</code>
                <div className="flex flex-wrap gap-1 mt-2">
                  {wh?.events?.map((e) => (
                    <span key={`event-${wh?.id}-${e}`} className="text-[10px] bg-zinc-800 border border-zinc-700 rounded px-2 py-0.5 text-zinc-500 font-mono">{e}</span>
                  ))}
                </div>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="flex items-center gap-1.5 justify-end mb-1">
                  {wh?.lastStatus === 200
                    ? <CheckCircle size={11} className="text-emerald-400" />
                    : <XCircle size={11} className="text-red-400" />
                  }
                  <span className={`text-xs font-mono font-bold ${wh?.lastStatus === 200 ? 'text-emerald-400' : 'text-red-400'}`}>{wh?.lastStatus}</span>
                </div>
                <p className="text-[10px] text-zinc-600">Last: {wh?.lastDelivery}</p>
                <p className={`text-[11px] font-semibold mt-0.5 ${wh?.deliveryRate >= 98 ? 'text-emerald-400' : wh?.deliveryRate >= 80 ? 'text-amber-400' : 'text-red-400'}`}>{wh?.deliveryRate}% delivery</p>
              </div>
            </div>
            <div className="flex items-center gap-2 mt-3 pt-3 border-t border-zinc-800">
              <button onClick={() => toast?.info('Sending test event...')} className="text-xs px-3 py-1.5 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 rounded-lg text-zinc-400 transition-all">Send Test</button>
              <button onClick={() => toast?.info('Editing webhook')} className="flex items-center gap-1 text-xs px-3 py-1.5 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 rounded-lg text-zinc-400 transition-all"><Edit2 size={11} /> Edit</button>
              <button onClick={() => toast?.error('Webhook endpoint removed')} className="ml-auto text-xs px-3 py-1.5 text-red-400 hover:bg-red-500/10 rounded-lg transition-all flex items-center gap-1"><Trash2 size={11} /> Remove</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}